"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const eventBus = require("@nextcloud/event-bus");
const browserStorage$1 = require("@nextcloud/browser-storage");
let token;
const observers = [];
function getRequestToken() {
  if (token === void 0) {
    token = document.head.dataset.requesttoken ?? null;
  }
  return token;
}
function onRequestTokenUpdate(observer) {
  observers.push(observer);
}
eventBus.subscribe("csrf-token-update", (e) => {
  token = e.token;
  observers.forEach((observer) => {
    try {
      observer(token);
    } catch (e2) {
      console.error("Error updating CSRF token observer", e2);
    }
  });
});
function getCSPNonce() {
  const meta = document?.querySelector('meta[name="csp-nonce"]');
  if (!meta) {
    const token2 = getRequestToken();
    return token2 ? btoa(token2) : void 0;
  }
  return meta.nonce;
}
const browserStorage = browserStorage$1.getBuilder("public").persist().build();
function getGuestNickname() {
  return browserStorage.getItem("guestNickname");
}
function setGuestNickname(nickname) {
  browserStorage.setItem("guestNickname", nickname);
}
let currentUser;
const getAttribute = (el, attribute) => {
  if (el) {
    return el.getAttribute(attribute);
  }
  return null;
};
function getCurrentUser() {
  if (currentUser !== void 0) {
    return currentUser;
  }
  const head = document?.getElementsByTagName("head")[0];
  if (!head) {
    return null;
  }
  const uid = getAttribute(head, "data-user");
  if (uid === null) {
    currentUser = null;
    return currentUser;
  }
  currentUser = {
    uid,
    displayName: getAttribute(head, "data-user-displayname"),
    isAdmin: !!window._oc_isadmin
  };
  return currentUser;
}
exports.getCSPNonce = getCSPNonce;
exports.getCurrentUser = getCurrentUser;
exports.getGuestNickname = getGuestNickname;
exports.getRequestToken = getRequestToken;
exports.onRequestTokenUpdate = onRequestTokenUpdate;
exports.setGuestNickname = setGuestNickname;
